"use client";

import { capturePageError } from "@/lib/problem-render-diagnostics";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { isServerActionNotFoundError } from "@/lib/serverActionUtils";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const isStaleServerAction = isServerActionNotFoundError(error);

  useEffect(() => {
    // 배포 교체로 자동 복구되는 stale Server Action 에러는 Sentry 노이즈를 만들지 않고
    // 새로고침만 한다. 그 외 진짜 에러만 Sentry에 보고.
    if (isStaleServerAction) {
      const timer = window.setTimeout(() => {
        window.location.reload();
      }, 1500);

      return () => window.clearTimeout(timer);
    }

    capturePageError(error);
  }, [error, isStaleServerAction]);

  if (isStaleServerAction) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center p-4">
        <div className="max-w-md text-center">
          <h2 className="mb-4 text-2xl font-bold text-emerald-700">
            페이지가 업데이트되었습니다
          </h2>
          <p className="mb-6 text-gray-600 dark:text-gray-400">
            새 버전과 연결하기 위해 페이지를 새로고침합니다.
          </p>
          <Button onClick={() => window.location.reload()} variant="default">
            지금 새로고침
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="max-w-md text-center">
        <h2 className="mb-4 text-2xl font-bold text-red-600">
          문제가 발생했습니다
        </h2>
        <p className="mb-6 text-gray-600 dark:text-gray-400">
          예상치 못한 오류가 발생했습니다. 문제가 자동으로 보고되었으며, 빠른
          시일 내에 해결하겠습니다.
        </p>
        {error.digest && (
          <p className="mb-4 text-sm text-gray-500">
            오류 ID: {error.digest}
          </p>
        )}
        <Button onClick={reset} variant="default">
          다시 시도
        </Button>
      </div>
    </div>
  );
}
